var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"margin-t-8"},[_vm._v(" "+_vm._s(_vm.subHeader)+" ")]),_c('p',{staticClass:"margin-t-4"},[_vm._v(" "+_vm._s(_vm.body)+" "),_c('a',{attrs:{"href":`tel:${_vm.supportNumber}`}},[_vm._v(" "+_vm._s(_vm.formattedSupportNumber)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }